import { useEffect, useState } from "react";

import { getCurrentUser, logout, type UserProfile } from "../data/auth";

export const InternalSidebar = ({
  active,
}: {
  active: "boards" | "profile";
}) => {
  const [user, setUser] = useState<UserProfile | null>(null);
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    getCurrentUser()
      .then(setUser)
      .catch(() => undefined);
  }, []);

  return (
    <aside
      className={`miboard-internal-sidebar ${
        collapsed ? "miboard-internal-sidebar--collapsed" : ""
      }`}
    >
      <div className="miboard-internal-sidebar__top">
        <a href="/app/boards" className="miboard-internal-sidebar__brand">
          <img
            src="/image/Logo%20Miboard.png"
            alt="MiBoard"
            className="miboard-internal-sidebar__brandLogo"
          />
        </a>
        <button
          type="button"
          className="miboard-internal-sidebar__collapseButton"
          onClick={() => setCollapsed((current) => !current)}
          aria-label={collapsed ? "Expandir menu" : "Recolher menu"}
          title={collapsed ? "Expandir menu" : "Recolher menu"}
        >
          ☰
        </button>
      </div>
      {user && !collapsed && (
        <div className="miboard-internal-sidebar__user">
          <strong>{user.profile.name}</strong>
          <br />
          {user.profile.email}
        </div>
      )}
      <nav
        className="miboard-internal-sidebar__nav"
        aria-label="Navegação principal"
      >
        <a
          href="/app/boards"
          className="miboard-internal-sidebar__navLink"
          data-selected={active === "boards"}
          title="Meus painéis"
        >
          <span className="miboard-internal-sidebar__navLabel">
            Meus painéis
          </span>
        </a>
        <a
          href="/app/profile"
          className="miboard-internal-sidebar__navLink"
          data-selected={active === "profile"}
          title="Perfil e conta"
        >
          <span className="miboard-internal-sidebar__navLabel">
            Perfil e conta
          </span>
        </a>
        <a
          href="/app?new=1"
          className="miboard-internal-sidebar__navLink"
          data-selected={false}
          title="Abrir editor"
        >
          <span className="miboard-internal-sidebar__navLabel">
            Abrir editor
          </span>
        </a>
        {user?.profile.role === "admin" && (
          <a
            href="/app/admin"
            className="miboard-internal-sidebar__navLink"
            data-selected={false}
            title="Administração"
          >
            <span className="miboard-internal-sidebar__navLabel">
              Administração
            </span>
          </a>
        )}
      </nav>
      <button
      type="button"
      onClick={() => {
        logout();
        window.location.assign("/app/login?next=%2Fapp%2Fboards");
      }}
        className="miboard-internal-sidebar__logout"
        aria-label="Sair"
        title="Sair"
      >
        <span
          className="miboard-internal-sidebar__logoutIcon"
          aria-hidden="true"
        >
          ↩
        </span>
        <span className="miboard-internal-sidebar__navLabel">Sair</span>
      </button>
    </aside>
  );
};
